<template lang="html">
  <div class="row no-margin track">
    <div v-if="hyperTrack.length" class="track-map">
      <iframe :src="currentConsignee.tracking_url"
        width="402" height="400" frameborder="0" style="border:0" allowfullscreen />
    </div>

    <div v-if="hyperTrack.length" class="track-map-list no-padding">
      <ul v-if="hyperTrack.length">
        <li v-for="track in hyperTrack" v-bind:key="track.consignee_id">
          <a href="javascript:void(0)"  v-bind:class="{'active':
            track.consignee_id === currentConsignee.consignee_id}"
            @click="setCurrentConsignee(track)">
            {{getConsigneeName(track.consignee_id).name}}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {

  props: ['order'],

  data() {
    return {
      currentConsignee: null,
    };
  },

  created() {
    this.currentConsignee = this.hyperTrack[0];
  },

  computed: {
    ...mapGetters({
      hyperTrack: 'order/hyperTrack',
    }),
  },

  methods: {
    getConsigneeName(id) {
      return this.order.consignees.find(consignee => consignee.id === id);
    },

    setCurrentConsignee(consignee) {
      this.currentConsignee = consignee;
    },

  },

};
</script>

<style lang="scss">
@import "~@common/styles-shipper/settings";
.track {
    //border: 1px solid #E8E8E8;
    &-map {
        display: inline-block;
        float: left;
        &-list {
            display: inline-block;
            ul {
                padding-left: 0;
                margin: 0;
                @extend %list-unstyled;
                li {
                    padding: 10px;
                    width: 140px;
                    border-bottom: 1px solid #E8E8E8;
                    text-align: left;
                    a {
                        font-size: 1.2rem;
                        color: #6E6E6E;
                        letter-spacing: 0.3px;
                        text-decoration: none;
                        &.active {
                            color: #008AFF;
                        }
                    }
                }
            }
        }
    }
}
</style>
